import { useState } from 'react';
import { ImageAndExpandableListV2, SanityKeyed, SanityBlock } from 'types/studio/studio';
import { ListItem } from './ListItem';

type Props = {
  openPopup: () => void;
  popupIsActive: boolean;
  sendNavigationEvent: (listHeadline: string) => void;
} & Pick<ImageAndExpandableListV2, 'expandableList' | 'theme'>;

const ExpandableList = ({
  expandableList,
  openPopup,
  popupIsActive,
  sendNavigationEvent,
  theme
}: Props) => {
  const [selectedListItem, setSelectedListItem] = useState<string>('');

  const handleToggleExpandableList = (id: string, headline: Array<SanityKeyed<SanityBlock>>) => {
    setSelectedListItem(id === selectedListItem ? '' : id);

    const headlineString = headline
      .map((block) => {
        if (block._type === 'block' && Array.isArray(block.children)) {
          return block.children.map((child) => child.text).join('');
        }
        return '';
      })
      .join('\n');

    if (id !== selectedListItem) {
      sendNavigationEvent(headlineString);
    }
  };

  if (!Array.isArray(expandableList) || expandableList.length === 0) {
    return null;
  }

  return (
    <>
      {expandableList.map((item) => (
        <ListItem
          key={item._key}
          item={item}
          popupIsActive={popupIsActive}
          openPopup={openPopup}
          isOpen={item._key === selectedListItem}
          onToggle={() => handleToggleExpandableList(item._key, item.headline)}
          theme={theme}
        />
      ))}
    </>
  );
};

export default ExpandableList;
